import React from 'react';

import PropTypes from 'prop-types';

import DMButton from 'apps/web_forms/components/commons/DMButton';

/**
 * @typedef {Object} button
 * @property {string} id
 * @property {string} label
 * @property {Function} onClick
 * @property {boolean} filled
 * @property {boolean} disabled
 * @property {string} className
 * @property {boolean} materialText
 */

/**
 *
 * @param {Object} props
 * @param {[button]} props.buttons
 */
const RenderButtons = ({ buttons }) => (
  <>
    {buttons?.map((button) => (
      <DMButton
        id={button.id}
        className={button?.className}
        key={button.id}
        callbackMethod={button.onClick}
        filled={
          button.filled === undefined || button.filled === null
            ? true
            : button.filled
        }
        disabled={button?.disabled}
        materialText={button?.materialText}
        mainColor={button?.mainColor}
      >
        {button.label}
      </DMButton>
    ))}
  </>
);

RenderButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      filled: PropTypes.bool,
      disabled: PropTypes.bool,
      materialText: PropTypes.bool,
      className: PropTypes.string,
      mainColor: PropTypes.string,
    })
  ),
};

RenderButtons.defaultProps = {
  buttons: [],
};

export default RenderButtons;
